<template lang="html">

  <section class="login">
    <div class="wrapper d-flex align-items-center auth login-full-bg">
      <div class="row w-100">
        <div class="col-lg-6 mx-auto">
          <div class="auth-form-dark text-left p-5">
            <h2>{{ $t('signin') }}</h2>
            <h4 class="pb-3 font-weight-light">{{ $t('signinDescription') }}</h4>
            <b-alert class="mt-alert" v-model="showInvalidCredentialAlert" dismissible>
              {{ $t('invalidCredential') }}
            </b-alert>
            <b-alert class="mt-alert" v-model="showLoginFailedAlert" dismissible>
              {{ $t('loginFailed') }}
            </b-alert>
            <b-alert class="mt-alert-info" v-model="showPasswordChangedAlert" dismissible>
              {{ $t('passwordChanged') }}
            </b-alert>
            <b-alert class="mt-alert-info" v-model="showSessionExpiredAlert" dismissible>
              {{ $t('sessionExpired') }}
            </b-alert>
            <form class="pt-3" @submit.prevent="login">
                <div class="form-group">
                  <label for="inputUsername">{{ $t('forms.email') }}</label>
                  <input type="text" v-model="credential.username" class="form-control" id="inputUsername" autocomplete="username" aria-describedby="emailHelp">
                  <i class="mdi mdi-account"></i>
                </div>
                <div class="form-group">
                  <label for="inputPassword">{{ $t('forms.password') }}</label>
                  <input type="password" v-model="credential.password" class="form-control" id="inputPassword" autocomplete="current-password">
                  <i class="mdi mdi-eye cursor-pointer" @mousedown="showPass" @mouseup="hidePass"></i>
                </div>
                <div class="mt-5">
                  <button type="submit" class="btn btn-block btn-warning btn-lg font-weight-medium">{{ $t('signin') }}</button>
                </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import {mapGetters} from "vuex";

export default {
  name: 'Login',
  computed: {
    ...mapGetters(['isLogged']),
    loginError() {
      return this.$store.state.loginError
    }
  },
  watch: {
    loginError(kind) {
      this.showInvalidCredentialAlert = kind === 'invalid'
      this.showLoginFailedAlert = kind === 'error'
    }
  },
  data() {
    return {
      showInvalidCredentialAlert: false,
      showLoginFailedAlert: false,
      showPasswordChangedAlert: false,
      showSessionExpiredAlert: false,
      credential: {
        username:'',
        password:''
      }
    }
  },
  mounted() {
    if (this.$route.query.invalidCredentials)
      this.showInvalidCredentialAlert = true

    if (this.$route.query.passwordChanged)
      this.showPasswordChangedAlert = true

    if (this.$route.query.sessionExpired)
      this.showSessionExpiredAlert = true

    if (this.isLogged)
      this.$router.push("/")
  },
  methods: {
    login() {
      this.$store.dispatch('login', this.credential);
    },
    showPass() {
        document.getElementById("inputPassword").type = "text";
    },
    hidePass() {
        document.getElementById("inputPassword").type = "password";
    }
  },
}
</script>

<style scoped lang="scss">
  .login, .wrapper {
    min-height: 100vh;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .mt-alert {
    border-color: rgba(94, 32, 32, 0.85);
    border-radius: 0;
    background-color: rgba(137, 52, 52, 0.52);
    color: white;
  }
  .mt-alert-info {
    border-color: rgba(38, 94, 32, 0.85);
    border-radius: 0;
    background-color: rgba(61, 143, 43, 0.52);
    color: white;
  }
</style>
